module.exports = __webpack_public_path__ + "static/media/filesearchicon.6d68bdc6.png";